import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Lazy from 'lazy.js'
import { errAlert } from '@/plugin/apiErrAlert'
import { SoundLib, getNowTime } from '@/plugin/tools'
axios.defaults.baseURL = process.env.API_ROOT
import createPersistedState from 'vuex-persistedstate'
import exam from './exam'
import note from './note'
import calendar from './calendar'
import today from './today'
Vue.use(Vuex)
export default new Vuex.Store({
    plugins: [
        // createPersistedState({
        //     key: 'Yse.Proeng',
        //     paths: ['loginData']
        // })
    ],
    state: {
        isIOS: require('is-ios'),
        stageWw: 0,
        soundLib: new SoundLib(),
        wordSound: new SoundLib(),
        loading: 0,
        menuOpen: true, //選單開關
        loginData: null,
        myLessons: null, //我的課程
        noteList: null,
        lessonExam: null, //測驗物件
        lessonExamList: null, //測驗物件陣列
        lessonExamListIndex: -1, //測驗物件陣列 index
        studyRecord: null, //取得全部學習紀錄(單字及測驗)
        recordData: null, //學習紀錄byDate(月曆使用)
        word: null, //顯示個別單字
        examEndMata: null, //顯示個別測驗結果
        classList: null, //課程內容
        selectDate: null, //日曆選擇的日期
        AddExamRecordMessage: ''
    },
    getters: {
        //分類後的筆記
        nodeGurup({ noteList }) {
            return Lazy(noteList)
                .groupBy(word => {
                    return word.Text.charAt(0).toUpperCase()
                })
                .sortBy(word => {
                    return word[0]
                })
                .toObject()
        },
        examDuration({ lessonExam }) {
            return lessonExam ? lessonExam.ExamDuration || null : null
        }
    },
    mutations: {
        setStageWw(state, ww) {
            state.stageWw = ww
        },
        setLoading(state, _f) {
            state.loading += _f ? 1 : -1
            state.loading = state.loading < 0 ? 0 : state.loading
        },
        setMenuOpen(state, _f) {
            state.menuOpen = _f
        },
        setLoginData(state, data = null) {
            state.loginData = data
        },
        setMyLessons(state, list) {
            //我的課程
            state.myLessons = list
        },
        //設定Node資料並分類
        setNoteList(state, list) {
            state.noteList = list
        },
        setLessonExam(state, exam) {
            state.lessonExam = exam
        },
        lessonExamList(state, list) {
            state.lessonExamList = list
            state.lessonExamListIndex = list ? 0 : -1
        },
        lessonExamListIndex(state, index) {
            state.lessonExamListIndex = index
        },
        soundLibInit(state, pathList) {
            state.soundLib.load(pathList)
        },
        setStudyRecord(state, data) {
            state.studyRecord = data
        },
        recordData(state, data) {
            state.recordData = data
        },
        word(state, word) {
            state.word = word
        },
        classList(state, data) {
            state.classList = data
        },
        selectDate(state, date) {
            state.selectDate = date
        },
        examEndMata(state, date) {
            state.examEndMata = date
        },
        AddExamRecordMessage(state, val) {
            state.AddExamRecordMessage = val
        }
    },
    actions: {
        async loginApi({ commit }, loginInfo) {
            commit('setLoading', true)
            try {
                let res = await axios.post('/api/Login/Login', loginInfo)
                commit('setLoginData', res.data)
            } catch (err) {
                // errAlert(err)
                alert('帳號或密碼輸入錯誤')
                commit('setLoginData', null)
            }
            commit('setLoading', false)
        },
        async logoutApi({ commit }) {
            commit('setLoginData', null)
            await axios.post('/api/Login/Logout')
        },
        async getTodayVocabulary({ commit, dispatch, state }, date = null) {
            commit('selectDate', date)
            let api = date
                ? '/api/Vocabulary/GetVocabularyByDate'
                : '/api/Vocabulary/GetTodayVocabulary'
            commit('setLoading', true)
            try {
                let res = await axios.get(api, {
                    params: {
                        studentId: state.loginData.Id,
                        date
                    }
                })
                commit('today/setTodayList', res.data)
            } catch (error) {
                errAlert(error)
                dispatch('logoutApi')
            }
            commit('setLoading', false)
        },
        //我的課程
        async getMyLessons({ commit, state }) {
            if (!state.loginData) return
            commit('setLoading', true)
            try {
                let res = await axios.get('/api/Lesson/GetMyLessons', {
                    params: {
                        studentId: state.loginData.Id
                    }
                })
                commit('setMyLessons', res.data)
            } catch (err) {
                errAlert(err)
                commit('setMyLessons', null)
            }
            commit('setLoading', false)
        },
        //取得課程測驗
        async getLessonExam({ commit, state }, date = getNowTime()) {
            if (!state.loginData) return
            commit('setLoading', true)
            commit('lessonExamListIndex', -1)
            try {
                let res = await axios.get('/api/Exam/GetDailyExam', {
                    params: {
                        studentId: state.loginData.Id,
                        date
                    }
                })
                // commit('setLessonExam', res.data)
                commit('lessonExamList', res.data)
            } catch (err) {
                errAlert(err)
                commit('lessonExamList', null)
            }
            commit('setLoading', false)
        },
        //取得課程測驗
        async getLessonExamById({ commit, state }, LessonId) {
            if (!state.loginData) return
            commit('setLoading', true)
            try {
                let res = await axios.get('/api/Exam/GetLessonExam', {
                    params: {
                        studentId: state.loginData.Id,
                        LessonId
                    }
                })
                commit('setLessonExam', res.data)
            } catch (err) {
                errAlert(err)
                commit('setLessonExam', null)
            }
            commit('setLoading', false)
        },
        //新增測驗紀錄
        async saveExamRecord({ commit, state }) {
            if (!state.lessonExam) return
            commit('setLoading', true)
            try {
                let res = await axios.post(
                    '/api/StudyRecord/AddExamRecord',
                    state.lessonExam
                )
                commit('AddExamRecordMessage', res.data.Message)
            } catch (err) {
                errAlert(err)
            }
            commit('setLoading', false)
        },
        async getMyNote({ commit, state }) {
            commit('setLoading', true)
            try {
                let res = await axios.get('/api/Note/GetMyNote', {
                    params: {
                        studentId: state.loginData.Id
                    }
                })
                commit('setNoteList', res.data)
            } catch (err) {
                errAlert(err)
            }
            commit('setLoading', false)
        },
        async addVocabularyToNote({ commit, state }, vocabularyId) {
            commit('setLoading', true)
            try {
                let res = await axios.post('/api/Note/AddVocabularyToNote', {
                    studentId: state.loginData.Id,
                    vocabularyId
                })
            } catch (err) {
                errAlert(err)
            }
            commit('setLoading', false)
        },
        async removeVocabularyFromNote(
            { commit, dispatch, state },
            vocabularyId
        ) {
            let reload = typeof vocabularyId === 'object'
            vocabularyId = vocabularyId.vocabularyId
            commit('setLoading', true)
            try {
                await axios.post('/api/Note/RemoveVocabularyFromNote', {
                    studentId: state.loginData.Id,
                    vocabularyId
                })
            } catch (err) {
                errAlert(err)
            }
            commit('setLoading', false)
            reload ? dispatch('getMyNote') : ''
        },
        //取得全部學習紀錄(單字及測驗) API
        async getMyStudyRecord({ commit, state }, date) {
            commit('selectDate', date)
            commit('setLoading', true)
            try {
                let res = await axios.get('/api/StudyRecord/GetMyStudyRecord', {
                    params: {
                        studentId: state.loginData.Id,
                        date
                    }
                })
                commit('setStudyRecord', res.data)
            } catch (err) {
                errAlert(err)
            }
            commit('setLoading', false)
        },
        //取得學習紀錄byDate(月曆使用)
        async getRecordByDate({ commit, state }, { startDate, endDate }) {
            commit('setLoading', true)
            try {
                let res = await axios.get('/api/StudyRecord/GetRecord', {
                    params: {
                        studentId: state.loginData.Id,
                        startDate,
                        endDate
                    }
                })
                commit('recordData', res.data)
            } catch (err) {
                errAlert(err)
            }
            commit('setLoading', false)
        },
        //取得課程內的單字
        async getVocabularyByLessonId({ commit, state }, LessonId) {
            commit('setLoading', true)
            try {
                let res = await axios.get(
                    '/api/Vocabulary/GetVocabularyByLessonId',
                    {
                        params: {
                            studentId: state.loginData.Id,
                            LessonId
                        }
                    }
                )
                commit('classList', res.data)
            } catch (err) {
                errAlert(err)
            }
            commit('setLoading', false)
        },
        //新增單字學習紀錄
        async addVocabularyRecord(
            { commit, state },
            { VocabularyId, Time, LessonId }
        ) {
            try {
                let res = await axios.post(
                    '/api/StudyRecord/AddVocabularyRecord',
                    {
                        MemberId: state.loginData.Id,
                        VocabularyId,
                        Time,
                        LessonId
                    }
                )
            } catch (err) {
                errAlert(err)
            }
        }
    },
    modules: {
        exam,
        note,
        calendar,
        today
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js